export default __webpack_public_path__ + "static/media/elevatorPosition.4bf9da6e.png";